import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';
import { useLocation, useNavigate } from 'react-router-dom';

import { useTranslation } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { RouterPage } from 'APP/router/constants';

export default ({ core }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const source = useAsObservableSource({
    core,
    location,
    navigate,
  });

  const presenter = useLocalStore(() => ({
    get core() {
      return source.core;
    },

    onCloseArticle() {
      if (!(core.hasSomethingData && core.payloads.isChanged)) {
        return presenter.goBack();
      }

      if (source.core.isEditMode) {
        presenter.showEditCloseConfirm();
      } else {
        presenter.showDraftCloseConfirm();
      }
    },

    async showEditCloseConfirm() {
      const canGoBack = await Tasks.app.showConfirm({
        title: t('channel_article_not_to_be_saved'),
        text: t('channel_article_confirm_leaving'),
        primaryText: t('common_leave'),
        secondaryText: t('common_cancel'),
      });

      if (canGoBack) {
        presenter.goBack();
      }
    },

    showDraftCloseConfirm() {
      Tasks.app.showConfirmWithCloseBtn({
        title: t('channel_article_save_as_draft'),
        text: t('channel_article_save_as_draft_info'),
        primaryText: t('common_save'),
        secondaryText: t('common_discard'),
        async onSuccess() {
          await source.core.handleCreateDraft();
          source.navigate(source.location.pathname.replace('/article', '/article-drafts'));
        },
        onCancel() {
          presenter.goBack();
        },
      });
    },

    goBack() {
      if (!source.core.isEditMode) {
        source.navigate(`/${RouterPage.Channels}/${core.group.id}`);
      } else {
        source.navigate(-1);
      }
    },
  }));

  return presenter;
};
